import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { LicenseOverviewModule } from '@portal-core/licenses/components/license-overview/license-overview.module';
import { LicenseProfileModule } from '@portal-core/licenses/components/license-profile/license-profile.module';
import { DialogAutoFocusModule } from '@portal-core/ui/dialog/directives/dialog-auto-focus/dialog-auto-focus.module';
import { SwitchBoardModule } from '@portal-core/ui/switch-board/switch-board.module';
import { LicenseAvatarModule } from "../license-avatar/license-avatar.module";
import { LicenseProfileDialogComponent } from './license-profile-dialog.component';

@NgModule({
  declarations: [
    LicenseProfileDialogComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    LoaderModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    LicenseProfileModule,
    DialogAutoFocusModule,
    MatTabsModule,
    LicenseOverviewModule,
    SwitchBoardModule,
    LicenseAvatarModule
  ],
  exports: [
    LicenseProfileDialogComponent
  ]
})
export class LicenseProfileDialogModule { }
